import { Error } from '../Error'
// import { Width } from '../Width'
import { Controller } from 'react-hook-form'

import { Label } from '@/components/ui/label'
import { UploadInput } from '@/components/ui/upload'
import { cn } from '@/utilities/ui'

import type { Control, FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

export const Upload: React.FC<{
  name: string
  defaultValue?: string
  label: string
  required: boolean
  width?: string
  errors: Partial<FieldErrorsImpl>
  register?: UseFormRegister<FieldValues>
  control?: Control<FieldValues>
  /** Uploads file to Media collection and returns the created doc (with id). Omit when uploadOnSubmit. */
  onUpload?: (file: File) => Promise<{ id: number }>
  /** When true, store File in form state and upload only on form submit */
  uploadOnSubmit?: boolean
  /** Optional: when this value changes (e.g. increment on form submit), upload clears selectedFile / UI */
  resetSignal?: boolean
  className?: string
  uploadWidth?: number
  uploadHeight?: number
}> = ({
  name,
  errors,
  label,
  required,
  control,
  onUpload,
  uploadOnSubmit = true,
  resetSignal,
  className,
  uploadWidth,
  uploadHeight,
}) => {
  return (
    <div
      className={cn('flex max-w-full flex-col', className)}
      style={{
        width: uploadWidth ? `${uploadWidth}px` : undefined,
      }}
    >
      <Label htmlFor={name}>
        {label}
        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      {control && (uploadOnSubmit || onUpload) ? (
        <Controller
          control={control}
          name={name}
          defaultValue={null}
          rules={{ required: required ? 'This field is required' : false }}
          render={({ field }) => (
            <UploadInput
              path={name}
              relationTo="media"
              value={field.value}
              onValueChange={field.onChange}
              onUpload={uploadOnSubmit ? undefined : onUpload}
              uploadOnSubmit={uploadOnSubmit}
              resetSignal={resetSignal}
              uploadWidth={uploadWidth}
              uploadHeight={uploadHeight}
            />
          )}
        />
      ) : (
        <UploadInput path={name} relationTo="media" resetSignal={resetSignal} />
      )}
      {errors[name] && <Error name={name} />}
    </div>
  )
}
